var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburgerMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1061_7632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5831 20C0.7092 20 0 19.2534 0 18.3334C0 17.4126 0.7092 16.6661 1.5831 16.6661H23.4162C24.291 16.6661 25.0002 17.4126 25.0002 18.3334C25.0002 19.2534 24.291 20 23.4162 20H1.5831ZM1.5831 11.6658C0.7092 11.6658 0 10.9203 0 9.99949C0 9.07946 0.7092 8.33316 1.5831 8.33316H23.4162C24.291 8.33316 25.0002 9.07946 25.0002 9.99949C25.0002 10.9203 24.291 11.6658 23.4162 11.6658H1.5831ZM1.5831 3.33291C0.7092 3.33291 0 2.58738 0 1.66632C0 0.745528 0.7092 0 1.5831 0H23.4162C24.291 0 25.0002 0.745528 25.0002 1.66632C25.0002 2.58738 24.291 3.33291 23.4162 3.33291H1.5831Z",
    fill: "#2B011C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1061_7632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.0002,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu);
export default __webpack_public_path__ + "static/media/hamburger-menu.f121a9d86189296b62aea826adfa0ee9.svg";
export { ForwardRef as ReactComponent };